import * as React from "react";
import protectedRoute from "../../protectedRoute";
import Container from "@mui/material/Container";
import { CssMessageTypography } from "../../styles/styled";
import Box from "@mui/material/Box";

function ConfirmPassword() {
  const strErr =
    "英大文字・英小文字・数字・記号（^ $ * . [ ] { } ( ) ? - \" ! @ # % & /  , > < ' : ; | _ ~ ` + =）の4種類を含んでいません";
  return (
    <React.Fragment>
      <Container
        style={{
          height: "50vh",
          display: "flex",
          alignItems: "center",
          minWidth: "1200px",
        }}
      >
        <Box style={{ margin: "0 auto" }}>
          <CssMessageTypography variant="button" display="block" gutterBottom>
            エラーが発生しました。
            <br />
            パスワード変更のメニューからやり直してください。エラーの内容としては以下が考えられます。
          </CssMessageTypography>
          <CssMessageTypography variant="button" display="block" gutterBottom>
            ・一定時間内の変更回数が上限を超えています
            <br />
            ・旧パスワードが間違っています
            <br />
            ・旧又は新パスワードが入力されていません
            <br />
            ・新パスワードが10文字以下になっています
            <br />
            ・新パスワードが {strErr}
          </CssMessageTypography>
        </Box>
      </Container>
    </React.Fragment>
  );
}

export default protectedRoute(ConfirmPassword);
